import React from 'react'
import { ConsentPage } from './ConsentPage'

export const CwaConsent = () => (
  <ConsentPage serviceName="CWA" servicePath="credit_assessment_service" />
)
